import request from '@/utils/request'

const fetchExportsList = (data) => {
  return request({
    path: '/merchants/get-reports',
    method: 'GET',
    data,
  })
}

const downloadExportsFromDates = (data) => {
  return request(
    {
      path: `/merchants/exports/download-all-exports`,
      method: 'GET',
      timeout: 100000, // ms
      data,
    },
    {
      responseType: 'arraybuffer',
      options: {
        camelizeRes: false,
        headers: {
          'Content-Type': 'application/zip',
        },
      },
    }
  )
}

export { fetchExportsList, downloadExportsFromDates }
